import React, { Component } from 'react';
//import { NavMenu } from './NavMenu';
import { BrandBar } from './brandbar'
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { initializeIcons } from '@uifabric/icons';
import { connect } from 'react-redux';

const tenantsWithoutBrandbar = [
    "e15ad8aa-7bf5-4dbe-b68d-f9460ea20eb3",  // M365B046383.onmicrosoft.com
    "adf1e1f5-5c6e-450e-a168-8f4de1d6740b"   // amwins.com
];

class MainLayout extends Component {
    displayName = MainLayout.name

    constructor(props) {
        super(props);
        initializeIcons();

        this.state = {
            showBrandBar: false
        };

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            showBrandBar: !(tenantsWithoutBrandbar.indexOf(nextProps.license.tenantId) >= 0)
        });
    }

    render() {
        const showBrandBar = this.state.showBrandBar;
        let footer;

        if (showBrandBar) {
            footer = <BrandBar />;
        } else {
            footer = <span></span>;
        }

        return (
            <Fabric>
                <div className="content-wrap">
                    <div id="main-content">
                        {this.props.children}
                    </div>
                    {footer}
                </div>
            </Fabric>
        );
    }
}

function mapStateToProps(state) {
    return {
        license: state.userRegLicense,
    };
}

export default connect(
    mapStateToProps,
)(MainLayout);


